document.addEventListener("DOMContentLoaded", initTableDragScroll);
window.addEventListener("load", initTableDragScroll);

function initTableDragScroll() {
    const containers = document.querySelectorAll(".short-schedule .price-table-wrap");
    if (!containers.length) return;

    containers.forEach(function (container) {
        if (container.dataset.dragScrollInit) return;
        container.dataset.dragScrollInit = "1";

        let isDragging = false;
        let startPageX = 0;
        let startScrollLeft = 0;
        let hasDragged = false;

        function canScroll() {
            return container.scrollWidth > container.clientWidth;
        }

        container.addEventListener("mousedown", function (event) {
            if (event.button !== 0 || !canScroll()) return;
            isDragging = true;
            hasDragged = false;
            startPageX = event.pageX;
            startScrollLeft = container.scrollLeft;
            container.classList.add("is-dragging");
        });

        container.addEventListener("mousemove", function (event) {
            if (!isDragging) return;
            event.preventDefault();
            const delta = event.pageX - startPageX;
            if (Math.abs(delta) > 3) hasDragged = true;
            container.scrollLeft = startScrollLeft - delta;
        });

        function endDrag() {
            isDragging = false;
            container.classList.remove("is-dragging");
        }

        container.addEventListener("mouseup", endDrag);
        container.addEventListener("mouseleave", endDrag);

        container.addEventListener(
            "click",
            function (event) {
                if (hasDragged) {
                    event.preventDefault();
                    event.stopPropagation();
                    hasDragged = false;
                }
            },
            true
        );
    });
}
